/* RESPONSIBLE TEAM: team-actions */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class SetupAction extends EmbercomBaseSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    ruleset: { embedded: 'always' },
  };
}
